import { Controller } from "@hotwired/stimulus"

// Chrome increments/decrements a focused <input type="number"> when the mouse
// wheel scrolls over it. Blurring on wheel drops that default action while the
// page keeps scrolling normally.
export default class extends Controller {
  blur() {
    this.element.blur()
  }
}
